module.exports = __webpack_public_path__ + "img/042_thumbnail.624bcefe.jpg";